
// TODO: wait for webpack to fix static analysis with dynamic importing using require.context
let marketingViews = [
  'blogs',
  'contactforms',
  'countersitestats',
  'domains',
  'emailhosting',
  'guestbooks',
  'home',
  'mailinglists',
  'messageforums',
  'onlinecalendars',
  'passwordprotect',
  'photoalbums',
  'sitebuilder',
  'sslcertificates',
  'webhosting',
  'onlinestore',
]

let siteblocksViews = [
  'templates'
]

const panelLayouts = {
  CONTENT_RIGHT: 0,
  CONTENT_LEFT: 1,
  CONTENT_CENTER: 2,
}

function normalizeLayouts(panels) {
  return panels.map(panel  => {
    panel.layout = panelLayouts[panel.layout]

    return panel
  })
}

let panels = {}
let serviceGardens = {}
for (let view of marketingViews) {
  let panelData = normalizeLayouts(require(`assets/data/${view}/panels.json`))
  panels[view.toUpperCase()] = panelData

  serviceGardens[view.toUpperCase()] = require(`assets/data/${view}/service-garden.json`)
}

siteblocksViews.forEach(view => {
  const panelData = normalizeLayouts(require(`assets/data/sitebuilder/${view}/panels.json`));
  panels[`SITEBUILDER_${view.toUpperCase()}`] = panelData;
});


let upgradeDetails = {}
let upgradeableServices = ['webhosting']
for (let service of upgradeableServices) {
  upgradeDetails[service] = require(`assets/data/${service}/upgrade-details.json`)
}

let globalSettings = {}
let servicesWithGlobalSettings = ['webhosting', 'domains']
for (let service of servicesWithGlobalSettings) {
  globalSettings[service] = require(`assets/data/${service}/global-settings.json`)
}

let legacyServiceMapping = {
  'blogs': "journal",
  'contactforms': "emailfwd",
  'countersitestats': "counter",
  'domains': "domains",
  'emailhosting': "emailhosting",
  'guestbooks': "guestbook",
  'home': "",
  'mailinglists': "bravemailer",
  'messageforums': "forum",
  'onlinecalendars': "calendar",
  'passwordprotect': "passwd",
  'photoalbums': "photocenter",
  'sitebuilder': "bravesites",
  'sslcertificates': "sslcertificates",
  'webhosting': "hosting"
}

export const SITEBLOCKS_HEADER_ROUTE_WHITELIST = [
  'sitebuilder',
  'sitebuilder/templates',
  'siteblocks',
  'siteblocks-templates'
];

export const PANELS = panels
export const SERVICE_GARDENS = serviceGardens
export const MARKETING_VIEWS = marketingViews
export const UPGRADE_DETAILS = upgradeDetails
export const GLOBAL_SETTINGS = globalSettings
export const PANEL_LAYOUTS = panelLayouts
export const LEGACY_SERVICE_MAPPING = legacyServiceMapping
export const HEADER_NAV_FLYOUT_ITEMS = [
  {
    "name": "CONTACT_FORMS",
    "to": "/contactforms",
  },
  {
    "name": "PASSWORD_PROTECT",
    "to": "/passwordprotect",
  },
  {
    "name": "PHOTO_ALBUMS",
    "to": "/photoalbums",
  },
  {
    "name": "GUEST_BOOKS",
    "to": "/guestbooks",
  },
  {
    "name": "ONLINE_CALENDARS",
    "to": "/onlinecalendars",
  },
  {
    "name": "MESSAGE_FORUMS",
    "to": "/messageforums",
  },
  {
    "name": "COUNTER_SITE_STATS",
    "to": "/countersitestats",
  },
  {
    "name": "ONLINE_STORES",
    "to": "/onlinestore",
  },
  {
    "name": "BLOGS",
    "to": "/blogs",
  },
  {
    "name": "divider"
  },
  {
    "name": "DOMAINS",
    "to": "/domains",
  },
  {
    "name": "EMAIL_HOSTING",
    "to": "/emailhosting",
  },
  {
    "name": "SSL_CERTIFICATES",
    "to": "/sslcertificates",
  },
  {
    "name": "SITE_BUILDER",
    "to": "/sitebuilder",
  },
  {
    "name": "WEB_HOSTING",
    "to": "/webhosting",
  },
  {
    "name": "EMAIL_MARKETING",
    "to": "/mailinglists",
  }
]

export const FOOTER_NAV_LINKS = [
  {
    name: "SERVICES",
    links: [{
      name: "WEB_HOSTING",
      href: "/webhosting"
    }, {
      name: "SITE_BUILDER",
      href: "/sitebuilder"
    }, {
      name: "EMAIL_HOSTING",
      href: "/emailhosting"
    }, {
      name: "BLOGS",
      href: "/blogs"
    }, {
      name: "EMAIL_MARKETING",
      href: "/mailinglists"
    }, {
      name: "DOMAINS",
      href: "/domains"
    }, {
      name: "SSL_CERTIFICATES",
      href: "/sslcertificates"
    }, {
      name: "CONTACT_FORMS",
      href: "/contactforms"
    }, {
      name: "PASSWORD_PROTECT",
      href: "/passwordprotect"
    }, {
      name: "PHOTO_ALBUMS",
      href: "/photoalbums"
    }, {
      name: "GUEST_BOOKS",
      href: "/guestbooks"
    }, {
      name: "MESSAGE_FORUMS",
      href: "/messageforums"
    }, {
      name: "ONLINE_CALENDARS",
      href: "/onlinecalendars"
    }, {
      name: "COUNTER_SITE_STATS",
      href: "/countersitestats"
    }, {
      name: "ONLINE_STORES",
      href: "/onlinestore"
    }]
  }, {
    multiRow: true,
    rows: [{
      name: "CONTACT",
      links: [{
        name: "SUPPORT_CENTER",
        href: "https://bravenet.com/help",
        external: true
      }, {
        name: "WEBMAIL_ACCESS",
        href: "https://webmail.bravehost.com",
        external: true
      }, {
        name: "ABUSE",
        href: "https://www.bravenet.com/global/abuse.php",
        external: true
      }, {
        name: "FACEBOOK",
        href: "https://www.facebook.com/bravenetwebservices",
        external: true
      }, {
        name: "X",
        href: "https://www.x.com/bravenet",
        external: true
      }]
    }, {
      name: "COMPANY",
      class: "pad-top",
      links: [{
        name: "ABOUT",
        href: "/about",
      }, {
        name: "WEB_DESIGN",
        href: "https://www.bravenetmarketing.com",
        external: true
      }, {
        name: "MARKETING_SEO",
        href: "https://www.bravenetmarketing.com",
        external: true
      }, {
        name: "SITE_MAP",
        href: "/sitemap"
      }, {
        name: "TERMS_OF_USE",
        href: "/terms"
      }, {
        name: "PRIVACY_POLICY",
        href: "/privacy-policy",
      }]
    }]
  },
]
